import React, { Dispatch, useEffect } from 'react';
import { Outlet, useParams } from 'react-router-dom';
import styled from 'styled-components';

import { fetchPermissionDetails } from '@actions/memberPortal/enrollmentsActionCreators';
import SideNavContainer from '@components/common/nav/SideNavContainer';
import withModalWrapper from '@containers/common/WithModalWrapper';
import { useAppDispatch } from '@hooks/index';
import { PAGE_TYPE } from '../utils';
import { modalConfig } from './modals/modalConfig';

const StyledContainer = styled.div`
    border: ${({ theme }) => `1px solid ${theme.gray8}`};
    background-color: ${({ theme }) => theme.white};
    box-sizing: border-box;
-   border-radius: 1rem;
    margin-bottom: 3rem;
    transition: 0.1s;
    box-shadow: 0 8px 16px rgba(175, 175, 193, 0.16);
    overflow: visible !important;
`;

function EnrollmentContainer() {
    const dispatch: Dispatch<any> = useAppDispatch();
    const { id } = useParams();

    useEffect(() => {
        dispatch(fetchPermissionDetails(id));
    }, [id]);

    return (
        <SideNavContainer page={PAGE_TYPE.ENROLLMENTS}>
            <StyledContainer className="desktop:grid-col-9 enrollment-history-container" id="main-content">
                <Outlet/>
            </StyledContainer>
        </SideNavContainer>
    );
}

export default withModalWrapper(EnrollmentContainer, modalConfig);
